module.exports = __webpack_public_path__ + "static/media/about-0.293fa289.jpg";